export const YAKIT_MODAL_PREFIX = 'YaKitModal';

export function yaKitModalTestId(modalRootTestId: string): string {
    return `${YAKIT_MODAL_PREFIX}.${modalRootTestId}`;
}

export function yaKitModalWrapperTestId(modalRootTestId: string): string {
    return `${yaKitModalTestId(modalRootTestId)}.Wrapper`;
}

export function yaKitModalCloseButtonTestId(modalRootTestId: string): string {
    return `${yaKitModalTestId(modalRootTestId)}.CloseButton`;
}

export function modalConfirmCancelButtonTestId(modalRootTestId: string): string {
    return `${modalRootTestId}.Cancel`;
}

export function modalConfirmCloseButtonTestId(modalRootTestId: string): string {
    return `${modalRootTestId}.CloseButton`;
}
